<template>
  <ul
    v-if="sellingPoints.length > 0"
    class="my-4 flex flex-col gap-3 pl-6 md:my-0 md:mt-4"
  >
    <li
      v-for="(sellingPoint, index) in sellingPoints"
      :key="index"
      class="list-disc text-base font-normal leading-4 md:text-base md:leading-5"
    >
      {{ sellingPoint }}
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { Product } from '@scayle/storefront-nuxt'
import { getAdvancedAttributeFirstValue } from '#layers/base/utils/advancedAttribute'

const props = defineProps<{
  product: Product
}>()

const sellingPoints = computed(() => {
  if (!props.product) {
    return []
  }

  const keys = [
    'sellingPoint1Dessin',
    'sellingPoint2Material',
    'sellingPoint3AGSSpezialDetail',
    'sellingPoint4InternEinkauf',
  ]

  return keys.reduce((acc, key) => {
    const value = getAdvancedAttributeFirstValue(props.product, key) as string
    if (value) {
      acc.push(value)
    }
    return acc
  }, [] as string[])
})
</script>
